// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__WjaQO","importantInfo":"styles_importantInfo__1-kK8"};